import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import Cart from '../../../shared-components/Cart/Cart';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CancelUrl, { COMPONENT_STYLE } from '../CancelUrl/CancelUrl';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import './Header.less';

const LOCALE_PREFIX = 'components/header/header';

export class Header extends Component {

    static propTypes = {
        cartAmount: PropTypes.string,
        contextType: PropTypes.string,
        pageName: PropTypes.string,
        displayLogout: PropTypes.bool,
        userLoggedIn: PropTypes.bool,
        intl: intlShape.isRequired,

        // Passed in props
        appPendHeaderStyle: PropTypes.bool,
        onCancel: PropTypes.func,
        singleColumnLayout: PropTypes.bool
    };

    static defaultProps = {
        appPendHeaderStyle: false,
        displayLogout: false,
        singleColumnLayout: true
    };

    isTransactional = () => {
        const { cartAmount } = this.props;

        if (cartAmount && cartAmount !== '0') {
            return true;
        }
    };

    displayLogout = () => {
        const { userLoggedIn, displayLogout = false } = this.props;

        if (!displayLogout || !userLoggedIn) {
            return null;
        }

        return (
            <a href="/ppcreditapply/logout"
                data-automation-id="logout"
                id="logout"
            >
                <FormattedMessage id={`${LOCALE_PREFIX}.log-out`} />
            </a>
        );
    };

    render() {
        const { intl, onCancel, singleColumnLayout, appPendHeaderStyle } = this.props;
        const isTransactional = this.isTransactional();

        return (
            <header className="Header">
                <div className="row-fluid">
                    <div className={singleColumnLayout ? 'span24' : 'span12'}>
                        <div id="cue-header" className={`clearfix section-border-bottom ${appPendHeaderStyle ? 'ap-header' : ''}`} >
                            <div id="cue-header-left" className="pull-left vertical-middle">
                                <div className="ppcredit-logo" role="img" aria-label={intl.formatMessage({ id: `${LOCALE_PREFIX}.ppc-logo` })} />
                            </div>
                            <div id="cue-header-right" className="pull-right vertical-middle">
                                {isTransactional && <Cart />}
                                {this.displayLogout()}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    return {
        cartAmount: _.get(state, 'serverData.cart.subtotal'),
        contextType: state.serverData.contextType,
        pageName: state.skeletonPage.currentPage,
        userLoggedIn: state.serverData.userLoggedIn
    };
};

export default connect(mapStateToProps)(injectIntl(Header));
